import * as React from 'react';
import {connect} from 'react-redux';

import {Field, formValueSelector} from 'redux-form';

import {FormField} from 'shells/form/form-field';

import {ReduxFormTextField} from '../../../core/form/fields';

import {FORM_NAME} from './constants';
import type {ActionType} from './types';

import styles from './after-submission-form.module.css';

const afterSubmissionSelector = formValueSelector(FORM_NAME);

function mapStateToProps(state: StateProps) {
    return {
        actionType: afterSubmissionSelector(state, 'actionType'),
    };
}

type StateProps = {
    actionType: ActionType;
};

type OwnProps = {
    disableRedirectUrl?: boolean;
};

type Props = OwnProps & StateProps;

export function AfterSubmissionFormComponent(props: Props) {
    const {actionType, disableRedirectUrl = false} = props;

    return (
        <div className={styles['after-submission-form']}>
            <div className={styles['form-description']}>When a person submits this form…</div>
            <FormField innerId='message'>
                <div className={styles['radio-row']}>
                    <label className={styles['form-label']}>
                        <Field name='actionType' component='input' type='radio' value='message' />
                        Show a success message
                    </label>
                </div>
                {actionType === 'message' ? (
                    <Field
                        name='message'
                        component={ReduxFormTextField}
                        multiline={true}
                        autoFocus={true}
                        selectOnFocus={true}
                        placeholder='Thank you for your submission! We can’t wait to talk to you.'
                        className={styles.textfield}
                    />
                ) : undefined}
            </FormField>
            <FormField innerId='redirectUrl'>
                <div className={styles['radio-row']}>
                    <label className={styles['form-label']}>
                        <Field
                            name='actionType'
                            component='input'
                            type='radio'
                            value='redirectUrl'
                            disabled={disableRedirectUrl}
                        />
                        Redirect to a URL
                    </label>
                </div>
                {actionType === 'redirectUrl' ? (
                    <Field
                        name='redirectUrl'
                        component={ReduxFormTextField}
                        autoFocus={true}
                        selectOnFocus={true}
                        placeholder='https://www.google.com'
                        className={styles.textfield}
                    />
                ) : undefined}
            </FormField>
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const AfterSubmissionForm = connector(AfterSubmissionFormComponent);
